export enum InvoiceStatus {
  Draft = 'draft',
  Unpaid = 'unpaid',
  Paid = 'paid',
  Viewed = 'viewed'
}

export default InvoiceStatus;
